export default "__VITE_PUBLIC_ASSET__07cf67c6__"